<div class="mat-table-container">
  <table mat-table [dataSource]="columnData" class="rde-table metadata-table">
    <ng-container matColumnDef="key">
      <th mat-header-cell *matHeaderCellDef>Key</th>
      <td mat-cell *matCellDef="let row" class="mat-column-key">{{ row.display_name }}</td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>Value</th>
      <td mat-cell *matCellDef="let row" class="mat-column-value">
        @if (row.link) {
          <a
            [href]="row.link"
            [attr.target]="row.link.startsWith('/') ? null : '_blank'"
            [attr.rel]="row.link.startsWith('/') ? null : 'noopener'"
          >
            {{ row.value }}
          </a>
        } @else if (Array.isArray(row.value)) {
          @for (rowValueItem of row.value; track $index) {
            <div>{{ rowValueItem }}</div>
          }
        } @else {
          {{ row.value }}
        }
      </td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
